import { useTranslation } from 'react-i18next';

// components
import { useSettingsContext } from '../components/settings';
// utils
import localStorageAvailable from '../utils/localStorageAvailable';
//
import { allLangs, defaultLang } from './config-lang';

const useLocales = () => {
  const { i18n, t: translate } = useTranslation();

  const { onChangeDirectionByLang } = useSettingsContext();

  const storageAvailable = localStorageAvailable();

  const langStorage = storageAvailable
    ? localStorage.getItem('i18nextLng')
    : '';

  const currentLang =
    allLangs.find((_lang) => _lang.value === langStorage) || defaultLang;

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang);
    onChangeDirectionByLang(newlang);
  };

  return {
    allLangs,
    currentLang,
    onChangeLang: handleChangeLanguage,
    translate: (text: any, options?: any) => translate(text, options),
  };
};

export default useLocales;
